// 组件对象，大写
import panguTag from './panguTag.vue'
export default panguTag
